import React, { memo } from 'react';
export const ExtendedTestimonialsSection = ({
  isInitial = false
}: {
  isInitial?: boolean;
}) => {
  const initialTestimonials = [{
    initials: 'LG',
    name: 'Lucas G.',
    city: 'Buenos Aires',
    desc: 'Estudiante UTN FRBA · 3er año Sistemas',
    quote: 'Aplazé Algoritmos 3 veces. Con el Módulo 1 del Mega Pack entendí la lógica de recursión en una tarde. Aprobé con 7. No lo puedo creer.'
  }, {
    initials: 'VM',
    name: 'Valentina M.',
    city: 'Córdoba',
    desc: 'Estudiante UNLP · 4to año Informática',
    quote: 'Los 50 prompts de IA del Bono 3 me cambiaron la forma de estudiar. Ahora tengo un tutor disponible las 24 horas. Aprobé POO y BD en el mismo mes.'
  }, {
    initials: 'MS',
    name: 'Matías S.',
    city: 'Rosario',
    desc: 'Desarrollador Backend Jr · 2 años cursando',
    quote: 'Conseguí mi primer trabajo como backend junior a los 3 meses de terminar el Módulo 6. El template de CV y la guía de entrevistas fueron exactamente lo que me faltaba.'
  }];
  const extendedTestimonials = [{
    initials: 'LG',
    name: 'Lucas G.',
    city: 'Buenos Aires',
    desc: 'Estudiante UTN',
    quote: 'Compré el viernes. El sábado ya estaba resolviendo ejercicios de árboles que antes no entendía. El Módulo 1 explica en 20 slides lo que el docente no pudo explicarme en todo el cuatrimestre.'
  }, {
    initials: 'VM',
    name: 'Valentina M.',
    city: 'Córdoba',
    desc: 'Estudiante UNLP',
    quote: 'El simulacro de oral del Módulo 5 me salvó. Le pedí a ChatGPT que me tomara el oral con el Prompt 22 del Bono 3. Aprobé Algoritmos con 8. Primera vez que apruebo en el primer intento.'
  }, {
    initials: 'MS',
    name: 'Matías S.',
    city: 'Rosario',
    desc: 'Backend Jr',
    quote: 'El Módulo 6 es literalmente un roadmap de cómo conseguir trabajo. Seguí el template de CV, activé el GitHub y a los 45 días tenía una oferta. USD 1.200 mensual remoto.'
  }, {
    initials: 'JP',
    name: 'Julián P.',
    city: 'Mendoza',
    desc: 'Estudiante UTN',
    quote: 'Las 50 queries SQL del Módulo 3 me prepararon para el final mejor que 3 semanas de estudio solo. El docente me preguntó exactamente una subconsulta correlacionada. La resolví de memoria.'
  }, {
    initials: 'LR',
    name: 'Lucía R.',
    city: 'La Plata',
    desc: 'Estudiante UNLP',
    quote: 'El Planificador del Bono 2 me cambió el cuatrimestre. Por primera vez no llegué a los finales sin haber estudiado. Aprobé 4 materias en el mismo período.'
  }, {
    initials: 'SR',
    name: 'Santiago R.',
    city: 'CABA',
    desc: 'Fullstack Jr',
    quote: 'Los Cheat Sheets del Bono 1 los tengo abiertos mientras programo. Python y SQL en una sola hoja. No volvería a trabajar sin ellos.'
  }, {
    initials: 'AR',
    name: 'Agustina R.',
    city: 'Tucumán',
    desc: 'Estudiante UADE',
    quote: 'Tres finales aplazados antes del Mega Pack. Cero aplazados después. La diferencia fue el método del Módulo 5. No estudié más horas. Estudié mejor.'
  }];
  const data = isInitial ? initialTestimonials : extendedTestimonials;
  return <section className={`py-10 md:py-16 px-4 md:px-6 ${isInitial ? 'bg-megapack-bg' : 'bg-megapack-card'}`} data-id="element-53">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-54">
        {!isInitial && <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-55">
            Lo que dicen los estudiantes que ya{' '}
            <br className="hidden sm:block" data-id="element-56" /> usan el Mega Pack:
          </h2>}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-57">
          {data.map((t, i) => <div key={i} className="bg-megapack-section border border-megapack-cyan/20 p-5 md:p-8 rounded-2xl card-hover flex flex-col" data-id="element-58">
              <div className="flex items-center gap-4 mb-4 md:mb-6" data-id="element-59">
                <div className="w-12 h-12 rounded-full bg-megapack-cyan text-megapack-bg flex items-center justify-center font-bold text-lg shrink-0" data-id="element-60">
                  {t.initials}
                </div>
                <div data-id="element-61">
                  <div className="text-megapack-gold text-sm mb-1" data-id="element-62">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <div className="font-bold text-sm" data-id="element-63">{t.name}</div>
                  <div className="text-megapack-gray text-[10px] uppercase tracking-wider" data-id="element-64">
                    {t.city}
                  </div>
                </div>
              </div>
              <p className="text-white/90 italic mb-4 md:mb-6 flex-grow leading-relaxed text-[15px]" data-id="element-65">
                "{t.quote}"
              </p>
              <div className="text-xs font-semibold text-megapack-cyan/80 pt-4 border-t border-white/5" data-id="element-66">
                {t.desc}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};